const VerticalLayout = () => import('@/layouts/VerticalLayout')

const supportList = () => import('./views/list')

export default [
  {
    path: '/support',
    name: 'support',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'support',
      component: supportList,
      meta: { name: 'support', userType: 'provider', serviceTypes: 'all' }
    }]
  }
]
